/* eslint-disable max-classes-per-file */

import { imageFallback } from "@/utils/error/imageError";

export interface RequestCrossSaleInterface {
  bookingNo: Array<string>;
}

class DestinationPresenter {
  id: number;

  city_id: number;

  city_name: string;

  city_slug: string;

  country_id: number;

  country_name: string;

  country_slug: string;

  constructor(res: any) {
    this.id = Number(res?.id ?? 1428);
    this.city_id = Number(res?.city_id ?? 0);
    this.city_name = res?.city_name ?? "";
    this.city_slug = res?.city_slug ?? "";
    this.country_id = Number(res?.country_id ?? 0);
    this.country_name = res?.country_name ?? "";
    this.country_slug = res?.country_slug ?? "";
  }
}
class FlihgtRoutePresenter {
  departure: string;

  arrival: string;

  constructor(res: any) {
    this.departure = res?.departure;
    this.arrival = res?.arrival;
  }
}

class CarLocarionPresenter {
  name: string;

  location_id: string;

  constructor(res: any) {
    this.name = res?.name ?? "";
    this.location_id = res?.location_id ?? "";
  }
}

export class CrossSaleDataPresenter {
  couponId: number;

  couponCode: string;

  product: string;

  productType: string;

  bookingInternalNo: string;

  title: string | null;

  subTitle: string | null;

  tooltip: string | null;

  pathImage169: string;

  pathImage43: string;

  startDate: string;

  endDate: string;

  destination: DestinationPresenter;

  flightRoute: FlihgtRoutePresenter;

  carLocation: CarLocarionPresenter;

  constructor(res: any) {
    this.couponId = res?.couponId ?? 0;
    this.couponCode = res?.couponCode ?? "";
    this.product = res?.product ?? "";
    this.productType = res?.productType ?? "";
    this.bookingInternalNo = res?.bookingInternalNo ?? "";
    this.title = res?.title ?? "";
    this.subTitle = res?.subTitle ?? "";
    this.tooltip = res?.tooltip ?? "";
    this.pathImage169 = res?.pathImage169 ?? imageFallback;
    this.pathImage43 = res?.pathImage43 ?? imageFallback;
    this.startDate = res?.startDate ?? "";
    this.endDate = res?.endDate ?? "";
    this.destination = new DestinationPresenter(res?.destination);
    this.flightRoute = new FlihgtRoutePresenter(res?.flightRoute);
    this.carLocation = new CarLocarionPresenter(res?.carLocation);
  }
}

export class ResponseCrossSalePresenter {
  status: boolean;

  message: string;

  data: Array<CrossSaleDataPresenter>;

  constructor(response: any) {
    this.status = response?.status || false;
    this.message = response?.message || "";
    this.data = response?.data?.map(
      (data: any) => new CrossSaleDataPresenter(data),
    );
  }
}
